module.exports = __webpack_public_path__ + "img/client_logo_1.3262f141.svg";